<template>
    <v-parallax
      dark
      id="home"
      style="background-color: #000; height: 100vh;"
    >
      <vue-particles
        color="#dedede"
        :particleOpacity="0.7"
        :particlesNumber="100"
        shapeType="circle"
        :particleSize="4"
        linesColor="#dedede"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        style="height: 100%;"
      >

      </vue-particles>
      <div class="text hidden-sm-and-down">
        
        <vue-typed-js
          style="font-size: 60px; color: #fff"
          :showCursor="true"
          :loop="true"
          :typeSpeed="50"
          :backSpeed="50"
          :strings="['{ One Chat Developer }', '{ Android }', '{ IOS }']">
          <span class="typing" style="font-size: 60px; color: #fff"></span>
        </vue-typed-js>
        <v-layout align-center column justify-center>
          <v-flex xs12 sm12 md12 xl12 lg12 style="margin-top: 4vh;">
            <v-btn outline color="white" class="btn-2" @click="linkdownload()">Download Application</v-btn>
            <v-btn outline color="white" class="btn-2" @click="linkAPI()">API documents</v-btn>
          <!-- <v-btn outline class="btn-2" @click="linkandroid()">Android Application</v-btn>
          <v-btn outline class="btn-2" @click="linkanios()">Ios Application</v-btn> -->
        </v-flex>
        </v-layout>
      </div>
      <div class="text hidden-md-and-up">
        <vue-typed-js
          style="font-size: 22px; color: #fff"
          :showCursor="true"
          :loop="true"
          :typeSpeed="50"
          :backSpeed="50"
          :strings="['{ One Chat Developer }', '{ Android }', '{ IOS }']">
          <span class="typing" style="font-size: 22px; color: #fff"></span>
        </vue-typed-js>
        <v-layout align-center column justify-center style="margin-top: 4vh;">
            <v-btn outline color="white" class="btn-2" @click="linkdownload()">Download Application</v-btn>
            <v-btn outline color="white" class="btn-2" @click="linkAPI()">API documents</v-btn>
        </v-layout>
      </div>
      <div class="footer hidden-sm-and-down">
        <v-layout align-center row justify-center>
            <p class="CSChatThai" style="text-align: right;"><b><a style="color: white;" :href="chatlink" target="_blank">One Chat</a> |</b></p>

            <p class="CSChatThai" style="text-align: right; padding-left: 5px;"><b><a style="color: white;" @click="toPage('/aboutus')">เกี่ยวกับเรา</a></b></p>

            <p style="padding-left: 20px; padding-right: 20px;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>

            <p class="CSChatThai" style="text-align: right;"><b><a style="color: white;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>
            
            <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: white;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
            
        </v-layout>
      </div>
      <div class="footer hidden-md-and-up">
        <v-layout align-center row justify-center>
            <p class="CSChatThai" style="text-align: right;"><b><a style="color: white;" :href="chatlink" target="_blank">One Chat</a> |</b></p>

            <p class="CSChatThai" style="text-align: right; padding-left: 5px; margin-right: 5px;"><b><a style="color: white;" @click="toPage('/aboutus')">เกี่ยวกับเรา</a> |</b></p>

            <p class="CSChatThai" style="padding-left: 0px;"><b><a style="color: white;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>

            <p class="CSChatThai" style="padding-left: 5px;"><b><a style="color: white;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
        </v-layout>
        <v-layout align-center row justify-center>
          <p style="padding-left: 20px; padding-right: 20px;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
        </v-layout>
      </div>
    </v-parallax>

</template>

<script type="text/javascript">
  export default {
    data: () => ({
      chatlink: ''
    }),
    created () {
      this.chatlink = process.env.API
    },
    methods: {
      linkdownload () {
        window.open('/download', '_blank').focus()
      },
      linkAPI () {
        window.open('/docs', '_blank').focus()
      },
      toPage (page) {
        this.$router.push(page)
      }
    }
}
</script>

<style type="text/css" scoped>
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #00afff !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000;
   color: white;
   text-align: center;
}
>>> div.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
}
  .btn-2 {
    letter-spacing: 0;
}

.btn-2:hover,
.btn-2:active {
  letter-spacing: 5px;
}

.btn-2:after,
.btn-2:before {
  backface-visibility: hidden;
  /*border-style: solid;
  border-radius: 1px;
  border-color: #fff;*/
  border: 1px solid rgba(#fff, 0);
  bottom: 0px;
  content: " ";
  display: block;
  margin: 0 auto;
  position: relative;
  transition: all 280ms ease-in-out;
  width: 0;
}

.btn-2:hover:after,
.btn-2:hover:before {
  backface-visibility: hidden;
  border-color: #fff;
  transition: width 350ms ease-in-out;
  width: 70%;
}

.btn-2:hover:before {
  bottom: auto;
  top: 0;
  width: 70%;
}
/*html, body {
  margin: 0;
  padding: 0;
}
.background {
  position: absolute;
  display:block;
  top: 0;
  left: 0;
  z-index: 0;
}*/
#particles-js {
  color: #fff;
  /*position: absolute;*/
  width: 100%;
  height: 100%;
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

$text: #fff;
$link: #e34234;
$link-hover: #ba160c;
$background: #00356B;

canvas {
  display: block;
  vertical-align: bottom;
}

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background
}

.text {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  /*background: rgba(0, 0, 0, 0.4);*/
  /*text-shadow: 0px 0px 2px #131415;*/
  font-family: 'CS ChatThaiUI' !important;
}

h1 {
  font-size: 2.25em;
  font-weight: 700;
  letter-spacing: -1px;
}

a,
a:visited {
  color: $link;
  transition: 0.25s;
}

a:hover,
a:focus {
  color: $link-hover;
}
</style>



// WEBPACK FOOTER //
// src/components/home/HomepageApi.vue